import styled from 'styled-components';

import { Dialog } from '@/modules/theme/components/Dialog/Dialog';
import { blue } from '@/modules/theme/utils/colors';

export const DialogStyled = styled(Dialog)(() => ({
  width: 768,
  maxWidth: '100%',
}));

export const FormWrapperStyled = styled('div')(({ theme: { spacing } }) => ({
  width: '100%',
  margin: `${spacing(4)} ${spacing(10)} 0 ${spacing(10)}`,
}));

export const FormRowStyled = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const TextRowStyled = styled('div')(({ theme: { spacing } }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: spacing(1),
}));

export const FormColStyled = styled('div')(() => ({
  width: '50%',
}));

export const EstimationTextsWrapperStyled = styled('div')(
  ({ theme: { spacing } }) => ({
    marginBottom: spacing(7),
  })
);

export const ButtonWrapperStyled = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
}));

export const HorizontalLineStyled = styled('hr')(({ theme: { spacing } }) => ({
  borderBottom: 'none',
  borderColor: blue['700'],
  margin: spacing([2, 0]),
}));
